// Sub-tabs: Balances | Compliance certificates | Send log.
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.

export default function SubTabs({ setSubTab, subTab }) {
  return (
    <>
      {/* Sub-tabs: Balances | Compliance certificates */}
      <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '0.75rem', borderBottom: '2px solid #e5e7eb' }}>
        {[['balances', 'Balances'], ['certificates', '🛡 Compliance certificates'], ['sendlog', '📨 Send log']].map(([k, label]) => (
          <button key={k} onClick={() => setSubTab(k)}
                  style={{
                    padding: '0.45rem 1rem', border: 'none', cursor: 'pointer',
                    borderBottom: subTab === k ? '3px solid #0f766e' : '3px solid transparent',
                    background: 'transparent', fontWeight: subTab === k ? 700 : 400,
                    color: subTab === k ? '#0f766e' : '#475569', fontSize: '0.95em'
                  }}>
            {label}
          </button>
        ))}
      </div>
    </>
  );
}
